import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosContratoChoiceEnum, gridSizeMdLg1, gridSizeMdLg12, gridSizeMdLg5, gridSizeMdLg6, hasAllPermissions, ROUTER_PATHS, TABLE_CONSTANTS, useLoaders, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { CustomAutocompleteArrString, GeneralTable, SingleIconButton } from "@/shared/components/ui";
import { SAVE_CLIENTE_CONTRATO_PERMISSIONS } from "@/shared/constants/form-permissions";
import { Contrato, ESTADOS_INFO_CONTRATO_CHOICE, EstadosActualizacionContratoEnum } from "@/shared/interfaces";
import { East, FilterAltOff } from "@mui/icons-material";
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ModalGenerarExcelContratos } from "../../../shared/components";
import { useFetchContratos } from "@/shared/actions/erp";
import { useNavigate } from "react-router-dom";
import { useColumnsClientes } from "../../../shared/hooks";

type Props = {
    filterParams?: any
}
type FormDataClientes = {
  estadoInformacionContrato: EstadosActualizacionContratoEnum;
};

const ClientesFibraTodos = ({
    filterParams
}: Props) => {
    const navigate = useNavigate();

    const [openGenerateReport, setOpenGenerateReport] = useState(false);

    const clientesFibraOpticaReturnUrl = ROUTER_PATHS.clientes.fibraOpticaNav;


    // server side filters - colums table
    const { 
        filterObject, 
        columnFilters, 
        setColumnFilters 
    } = useTableServerSideFiltering();


    const {
    // globalFilter,
    pagination,
    searchTerm,
    // onChangeFilter,
    setPagination,
    // cleanFilter,
    } = useTableFilter();
    const { pageIndex, pageSize } = pagination;

    ///* form ---------------------------
    const form = useForm<FormDataClientes>({
    defaultValues: {
        estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    },
    });

    const watchedContratoInfoState = form.watch("estadoInformacionContrato");

    ///* fetch data ---------------------------
    const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
    } = useFetchContratos({
    params: {
        page: pageIndex + 1,
        page_size: pageSize,
        identificacion: searchTerm,

        estado_actualizacion_exclude: "REVISADO",
        ...(watchedContratoInfoState !== EstadosActualizacionContratoEnum.ALL && {
        estado_actualizacion:
            watchedContratoInfoState ==
            EstadosActualizacionContratoEnum.PENDIENTE_REVISION
            ? "ACTUALIZADO"
            : watchedContratoInfoState,
        // : watchedContratoInfoState == EstadosActualizacionContratoEnum.APROBADO ?
        //   "REVISADO"
        }),
        tipo_servicio: "FIBRA",
        preventa_estado_aceptacion: true,
        estado_contrato_in: `${EstadosContratoChoiceEnum.ACTIVO},${EstadosContratoChoiceEnum.SUSPENDIDO}`,
        ...filterParams,
        ...filterObject,
    },
    });

    ///* handlers ---------------------------
    const onEdit = (original: Contrato) => {
        navigate(`${clientesFibraOpticaReturnUrl}/ver/${original.id_contrato}`);
    };

    ///* columns ---------------------------
    const { clientesFibraColumns } = useColumnsClientes();

    ///* effects ---------------------------
    useLoaders(isLoadingContratos || isRefetchingContratos);








    return (
        <Grid item container {...gridSizeMdLg12}>
            <Grid container spacing={1} {...gridSizeMdLg12} sx={{ marginBottom: 4 }}>
            {/* <Grid item> */}
            <CustomAutocompleteArrString
              size={gridSizeMdLg6}
              label="Estado Contrato"
              name="estadoInformacionContrato"
              control={form.control}
              defaultValue={
                form.getValues().estadoInformacionContrato ||
                EstadosActualizacionContratoEnum.ALL
              }
              options={ESTADOS_INFO_CONTRATO_CHOICE}
              isLoadingData={false}
              error={form.formState.errors.estadoInformacionContrato}
              helperText={form.formState.errors.estadoInformacionContrato?.message}
              // size={gridSizeMdLg12}
              disableClearable
            />
            <Grid item>
              <SingleIconButton
                size={gridSizeMdLg1}
                startIcon={<FilterAltOff />}
                onClick={() => {
                  form.setValue(
                    'estadoInformacionContrato',
                    EstadosActualizacionContratoEnum.ALL
                  );
                }}
              />
            </Grid>
            <Grid item container {...gridSizeMdLg5} alignContent={"center"} justifyItems={"center"} justifyContent={"end"}>
              <Button
                onClick={() => setOpenGenerateReport(true)}
                variant="outlined"
                sx={{
                  py: 1,
                  my: 0,
                  marginX: 1,
                }}
                size="small"
              >
                Generar Reporte por Fechas
              </Button>
            </Grid>
          </Grid>
          <GeneralTable<Contrato>
            columns={clientesFibraColumns}
            data={contratosPagingRes?.data?.data || []}
            //
            isLoading={isLoadingContratos}
            isRefetching={isRefetchingContratos}
            // // filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={contratosPagingRes?.data?.count}
            // // actions ========
            enableColumnActions={hasAllPermissions([
              ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
            ])}
            enableEditing={hasAllPermissions([
              ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
            ])}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
            // crud
            canEdit={hasAllPermissions([
              ...SAVE_CLIENTE_CONTRATO_PERMISSIONS,
            ])}
            // onEdit={onEdit}
            onCustomEdit={(r) =>
              r.estado_contrato == EstadosContratoChoiceEnum.CANCELADO ? "" :
                <Tooltip title={"Ir a detalle"} placement='top'>
                  <IconButton
                    onClick={() => {

                      if (!hasAllPermissions([
                        PermissionsEnum.api_change_contrato,
                        PermissionsEnum.api_add_contrato
                      ]))
                        return toast.error('Acceso denegado. No cumples con los permisos necesarios: [403]')

                      onEdit(r!);
                    }}
                  >
                    <East />
                  </IconButton>
                </Tooltip>
            }
            // editIcon={<EastIcon />}
            toolTipTitleEditIcon="Ir a detalle"
            canDelete={false}
          />

            {openGenerateReport ? (
                <ModalGenerarExcelContratos
                open={openGenerateReport}
                setOpen={setOpenGenerateReport}
                />
            ) : null}
        </Grid>
  )
}

export default ClientesFibraTodos